// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollIndicator_scroll__pdSXd","hidden":"ScrollIndicator_hidden__rBCBH","arrow":"ScrollIndicator_arrow__59hVY"};